import { styled, Typography, Box } from '@mui/material';

export const Section = styled('div')`
  width: 100%;
  position: relative;
  padding-left: 15px;
  padding-right: 15px;

  .CardBox{
    
    @media (max-width: 767px){
      max-width: 340px;
      width: 100%;
      margin-left: auto;
      margin-right: auto;
    }
  }
`;

export const Wrapper = styled(Box)`
  width: 100%;
  max-width: 1091px;
  margin-left: auto;
  margin-right: auto;
`;

export const DescriptionText = styled(Typography)`
  font-size: 16px;
  line-height: 1.5;
  margin-top: 12px;
  color: #C0C0C0;

  @media (min-width: 768px){
    font-size: 18px;
  }

  a{
    color: #E3C050;
    text-decoration: none;

    &:hover{
      text-decoration: underline;
    }
  }
`;